import { useEffect } from 'react';
import { removeAllGlobalStyles } from '../utils/globalStyles';
import { useLoadFontStyles } from '../../../hooks/fonts/useLoadFontStyles';
import { useLoadGlobalStyles } from '../../../hooks/useLoadGlobalStyles';
import { useLoadBulkVariantStyles } from '../../../hooks/useLoadVariantStyles';
export const StylesLoader = ({
  bulkVariantOverrides,
  fields,
  globalStyles
}) => {
  const {
    loadCssVarMap
  } = useLoadGlobalStyles({
    fields,
    globalStyles
  });
  const {
    fontsToLoad,
    loadFontStyles
  } = useLoadFontStyles({
    fields,
    globalStyles
  });

  // TEMP - ideally the BE would include variant styles in the CSS var map
  // so we should be able
  useLoadBulkVariantStyles({
    bulkVariantOverrides
  });
  useEffect(() => {
    for (const font of fontsToLoad) {
      void loadFontStyles(font);
    }
    loadCssVarMap(globalStyles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    return () => {
      removeAllGlobalStyles();
    };
  }, []);
  return null;
};